import { useTranslation } from "react-i18next";


const HeroHeader = () => {
    const { t } = useTranslation();
    return (
        <div className="w-full hero-section">
            <div className="grid">
                <div
                    id="hero"
                    className="col-12 lg:col-12 xl:col-12  bg-cover bg-no-repeat text-center"
                    style={{
                        backgroundRepeat: 'no-repeat',
                        // paddingTop: '60px',
                        background:
                            'radial-gradient(circle at top, #0a3a66 0%, #052542 60%)',
                        backgroundImage: `url(${require('src/assets/visual_assets/mc_banner.png')})`,
                        height: '250px',
                        backgroundPositionY: '26%',
                    }}
                >
                    <div className="grid align-items-start mt-0 mb-4">
                        <div className="col-12 text-center lg:text-left px-4 md:px-6">
                            <img
                                src="../../../assets/visual_assets/mc_fr_banner_head.png"
                                alt="Mastercard Banner"
                                className="mb-2"
                                style={{
                                    width: 'auto',
                                    height: '56.49px',
                                }}
                            />

                            <h1 className="text-3xl font-bold text-white line-height-2 m-0">
                                {t("landing.mastercard_roaming_title")}
                            </h1>

                            <p
                                className="text-white mt-3 font-medium"
                                style={{
                                    fontStyle: 'italic',
                                    fontSize: '18px',
                                    lineHeight: '150%',
                                }}
                            >
                                  {t("landing.mastercard_roaming_subtitle")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroHeader;